// src/pages/Home.js
import HeroSection from '../components/HomePage/HeroSection';
import FeaturedModels from "../components/HomePage/FeaturedModels";

const Home = () => {
  return (
    <div>
    <HeroSection />
    <FeaturedModels />
    </div>
  );
};

export default Home;
